import { DeviceCreateStatus } from 'consts'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const createStatusBadgeColors: Record<number, string> = {
  [DeviceCreateStatus.New]: 'bg-success',
  [DeviceCreateStatus.Resurrected]: 'bg-warning',
  [DeviceCreateStatus.Duplicated]: 'bg-danger',
}

const createStatusBadgeLabels: Record<number, string> = {
  [DeviceCreateStatus.New]: 'New',
  [DeviceCreateStatus.Resurrected]: 'Resurrected',
  [DeviceCreateStatus.Duplicated]: 'Duplicated',
}

const CreateStatusBadgeFormatter = ({ value, row }: any) => {
  const isReplacement = row?.is_replacement === true
  const badgeClass =
    !isReplacement && row?.updated_at === null && row?.created_at !== null
      ? createStatusBadgeColors[row?.create_status]
      : undefined

  return (
    <span className='position-relative' style={{ paddingLeft: '12px' }}>
      {isReplacement && (
        <OverlayTrigger placement='top' overlay={<Tooltip>Device Replacement Record</Tooltip>}>
          <span
            className='bg-secondary position-absolute rounded-circle'
            style={{ width: '8px', height: '8px', top: '0', left: '0', cursor: 'help' }}
          />
        </OverlayTrigger>
      )}
      {!isReplacement && badgeClass && (
        <OverlayTrigger
          placement='top'
          overlay={<Tooltip>{createStatusBadgeLabels[row.create_status]}</Tooltip>}
        >
          <span
            className={`${badgeClass} position-absolute rounded-circle`}
            style={{ width: '8px', height: '8px', top: '0', left: '0', cursor: 'help' }}
          />
        </OverlayTrigger>
      )}
      {value}
    </span>
  )
}

export default CreateStatusBadgeFormatter
